module.exports = __webpack_public_path__ + "static/media/primavera.4c479522.jpg";